import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {Group} from "../../models/group";

@Injectable({
    providedIn: 'root'
})
export class GroupService {

    public group: Group = null;
    public groups: Array<Group> = [];
    public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private http: HttpClient,
    ) {}

    getAllMyGroups(projectId, databaseId) {
        return this.http.get(this.getPath(projectId, databaseId)).pipe(
            tap(data => this.groups = data['data']['groups'])
        )
    }

    postGroup(projectId, databaseId, group: Group) {
        return this.http.post(this.getPath(projectId, databaseId), group.getObj(true)).pipe(
            tap(
                data => {
                    this.group = new Group(data['data']['group']);
                    this.groups.push(this.group);
                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    getSingleGroup(projectId, databaseId, groupId) {
        return this.http.get(this.getPath(projectId, databaseId) + '/' + groupId).pipe(
            tap(
                data => {
                    this.group = new Group(data['data']['group']);

                    const index = this.groups.findIndex(m => m["_id"] === data['data']['group']['_id']);

                    if (index > -1)
                        this.groups[index] = this.group;
                    else
                        this.groups.push(this.group);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    patchGroup(projectId, databaseId, groupId, group: Group) {
        return this.http.patch(this.getPath(projectId, databaseId) + '/' + groupId, group.getObj(true)).pipe(
            tap(
                data => {
                    this.group = new Group(data['data']['group']);

                    const index = this.groups.findIndex(db => db["_id"] === groupId);

                    if (index > -1)
                        this.groups[index] = this.group;
                    else
                        this.groups.push(this.group);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    deleteGroup(projectId, databaseId, groupId) {
        return this.http.delete(this.getPath(projectId, databaseId) + '/' + groupId).pipe(
            tap(
                () => {
                    if (this.group._id === groupId)
                        this.group = null;

                    this.groups.splice(this.groups.findIndex(m => m["_id"] === groupId), 1);

                    this.onChange.emit(true);
                },
                err => console.error(err)
            )
        );
    }

    private getPath(projectId, databaseId) {
        return '/api/v1/projects/' + projectId + '/databases/' + databaseId + '/groups';
    }
}
